import { safeStorage } from "@utils/safeStorage"
import { useState } from "react"

export function useAutoplayTrailer() {
  const [canPlay, setCanPlay] = useState(env.client ? safeStorage.getItem("autoplay-trailer") === "true" : false)

  const setPlay = (play: boolean) => {
    safeStorage.setItem("autoplay-trailer", String(play))
    setCanPlay(play)
  }

  return { autoplayTrailer: canPlay, setAutoplayTrailer: setPlay }
}
